import Flex from '@Components/Bases/Flex';
import { useGetReportList } from '@Domains/Reports';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useState } from 'react';
import { useProfile } from 'src/Constant/UserProfileContext/UserProfileProvider';
import LandingTopic from './Containers/LandingTopic';
import ReportList from './Containers/ReportList/ReportList';
import ReportTopicDetail from './Containers/ReportTopicDetail';
import Steppers from './Containers/Stepper';

const Landing = () => {
  const [selectedYear, setSelectedYear] = useState<string>('');
  const { user } = useProfile();
  const companyId = user?.I_COMPANY_ID;
  const [{ data, loading, error }, refetch] = useGetReportList(
    Number(companyId)
  );

  const filterYear = data
    ?.map((report) => report.startOperatingYear)
    .filter((year, index, self) => year && self.indexOf(year) === index)
    .sort((prevYear, lastedYear) => lastedYear - prevYear);

  const filteredData = selectedYear
    ? data?.filter(
        (report) => report.startOperatingYear === Number(selectedYear)
      )
    : data;

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex
        px={{ xs: 2, sm: 4 }}
        py={2}
        bgcolor="white"
        flexDirection="column"
        alignItems="center"
      >
        <Typography textAlign="center" color="error">
          เกิดข้อผิดพลาดในการโหลดข้อมูล กรุณาลองใหม่
        </Typography>
      </Flex>
    );
  }

  return (
    <Box minHeight={'100vh'} width={'100%'} bgcolor={'#f2f2f2'} px={16} py={4}>
      <LandingTopic data={data} refetch={refetch} />
      <Box py={2}>
        <Steppers />
      </Box>
      {data && data.length !== 0 && (
        <Flex py={4} width={1} justifyContent={'center'}>
          <ReportTopicDetail
            years={filterYear || []}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />
        </Flex>
      )}
      <ReportList data={filteredData} refetch={refetch} />
    </Box>
  );
};

export default Landing;
